import { render, staticRenderFns } from "./PriceTables.vue?vue&type=template&id=9879964c&"
import script from "./PriceTables.vue?vue&type=script&lang=js&"
export * from "./PriceTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports